import { IChooseItems } from '../../../../components/mainContent/TableAllDishes'
import { IEdgeServers } from '../../../../core/api/dto/BuffetDishDto'
import React, { useState } from 'react'
import {
  AppNotification,
  NotificationType,
} from '../../../../components/notification/Notification'
import { useTranslation } from 'react-i18next'
import { IPlanMenuTypeDto } from '../../../../core/api/dto/PlanMenuTypeDto'
import {
  useDeletePlanMenuTypeToFotoboxesMutation,
  useSendPlanMenuTypeToFotoboxesMutation,
} from '../../../../core/api/PlanMenuTypeApi'
import { uniqFilter } from '../../DishesPage/hooks/useSentOnFotobox'

interface UseSentPlanMenuTypeOnFotoboxProps {
  chooseItems: IChooseItems | null
  tableData: IPlanMenuTypeDto[]
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>
}

interface UseSentPlanMenuTypeOnFotoboxResponse {
  isDeleteMode: boolean
  deleteStations: IEdgeServers[] | null
  sentPopup: boolean
  closeSentPopup: () => void
  openDeleteStationPopup: () => void
  openSentPopup: () => void
  onSendPlanMenuType: (value: string[]) => void
  onDeletePlanMenuTypeStation: (value: string[]) => void
  isLoadingSend: boolean
}

export const useSentPlanMenuTypeOnFotobox = ({
  tableData,
  chooseItems,
  setChooseItems,
}: UseSentPlanMenuTypeOnFotoboxProps): UseSentPlanMenuTypeOnFotoboxResponse => {
  const { t } = useTranslation()
  const [sentPopup, setSentPopup] = useState(false)
  const [isDeleteMode, setIsDeleteMode] = useState(false)
  const [deleteStations, setDeleteStations] = useState<IEdgeServers[] | null>(
    null,
  )

  const [sendPlanMenuTypeToFotoboxes, { isLoading: isLoadingSend }] =
    useSendPlanMenuTypeToFotoboxesMutation()
  const [deletePlanMenuTypeToFotoboxes] =
    useDeletePlanMenuTypeToFotoboxesMutation()

  const choosePlanMenuType = tableData
    .filter((item) => chooseItems && chooseItems[item.id] && !item.archived)
    .map((item) => item.guid)

  const closeSentPopup = () => {
    setSentPopup(false)
    setIsDeleteMode(false)
    setDeleteStations(null)
  }
  const openDeleteStationPopup = () => {
    setSentPopup(true)
    setIsDeleteMode(true)
    const deleteStation = uniqFilter(
      tableData
        .filter((item) => chooseItems && chooseItems[item.id] && !item.archived)
        .map((item) => item.edgeServers)
        .flat(1),
    )
    setDeleteStations(deleteStation)
  }
  const openSentPopup = () => setSentPopup(true)

  const onSendPlanMenuType = (value: string[]) => {
    if (value.length && choosePlanMenuType.length) {
      sendPlanMenuTypeToFotoboxes({
        planMenuTypesGuids: choosePlanMenuType,
        edgeServersGuids: value,
      })
        .unwrap()
        .then(() => {
          AppNotification({
            type: NotificationType.success,
            msg: t('Типы план-меню успешно отправлены на выбранные станции'),
          })
          setChooseItems(null)
          setSentPopup(false)
        })
    }
  }
  const onDeletePlanMenuTypeStation = (value: string[]) => {
    if (value.length && choosePlanMenuType.length) {
      deletePlanMenuTypeToFotoboxes({
        planMenuTypesGuids: choosePlanMenuType,
        edgeServersGuids: value,
      })
        .unwrap()
        .then(() => {
          AppNotification({
            type: NotificationType.success,
            msg: t('Типы план-меню успешно удалены с выбранных станций'),
          })
          setChooseItems(null)
          setSentPopup(false)
          setIsDeleteMode(false)
          setDeleteStations(null)
        })
    }
  }

  return {
    isDeleteMode,
    deleteStations,
    sentPopup,
    closeSentPopup,
    openSentPopup,
    openDeleteStationPopup,
    onDeletePlanMenuTypeStation,
    onSendPlanMenuType,
    isLoadingSend,
  }
}
